import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { daDate } from "@/lib/date";
import { CalendarClock } from "lucide-react";

const OPTS = [["30", "30 dage"], ["90", "90 dage"], ["180", "180 dage"], ["365", "1 år"], ["date", "Vælg dato…"], ["none", "Intet udløb"]];

export const ShareExpiry = ({ kind, docId, expiresAt, onChange, disabled = false }) => {
  const [busy, setBusy] = useState(false);
  const expired = expiresAt && expiresAt <= new Date().toISOString();
  const apply = async (val) => {
    let body;
    if (val === "none") body = { remove: true };
    else if (val === "date") { const d = window.prompt("Udløbsdato (ÅÅÅÅ-MM-DD):"); if (!d) return; body = { date: d }; }
    else body = { days: parseInt(val, 10) };
    setBusy(true);
    try { const { data } = await api.patch(`/share-links/${kind}/${docId}/expiry`, body); onChange?.(data.share_expires_at); toast.success(data.share_expires_at ? `Linket udløber ${daDate(data.share_expires_at)}` : "Linket udløber ikke"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs" data-testid={`share-expiry-${kind}`}>
      <CalendarClock className="h-3.5 w-3.5 text-stone-400" strokeWidth={1.75} />
      <span className={expired ? "text-[#A83232] font-semibold" : "text-stone-600"} data-testid="share-expiry-label">
        {expiresAt ? (expired ? `Udløbet ${daDate(expiresAt)}` : `Udløber ${daDate(expiresAt)}`) : "Intet udløb"}
      </span>
      <select disabled={disabled || busy} defaultValue="" onChange={(e) => { if (e.target.value) { apply(e.target.value); e.target.value = ""; } }}
        className="h-7 rounded-lg border border-[#EBE8E3] bg-white px-2 text-xs text-stone-700" data-testid="share-expiry-select">
        <option value="">Ændr udløb…</option>
        {OPTS.map(([v, l]) => <option key={v} value={v}>{v === "180" ? "Forlæng 180 dage" : l}</option>)}
      </select>
    </div>
  );
};

export const ShareExpiredPage = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#FBFAF8] p-6" data-testid="share-expired-page">
    <div className="max-w-md text-center rise-in">
      <img src="/bsm-logo.png" alt="BSM A/S" className="h-9 w-auto mx-auto mb-8" />
      <p className="label-caps">Delingslink</p>
      <h1 className="text-3xl font-light tracking-tight mt-2 text-[#1A1919]">Linket er udløbet</h1>
      <p className="text-sm text-stone-500 mt-4 leading-relaxed">Af sikkerhedshensyn udløber delingslinks efter en periode. Kontakt din kontaktperson hos BSM for at få et nyt link.</p>
    </div>
  </div>
);

export const isExpiredError = (e) => e?.response?.status === 410;
